import { useState, useMemo } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Dialog, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useTheme, Theme } from "@mui/material";

import { accountSwitch } from "../../API/apiAuth";
import { AccountModel, InternalAccountAssignedModel } from "../../Models/account";
import { updateAccountAssigned } from "../../../../store/actions/auth_actions";

import SelectAccount from "./SelectAccount";
import { pathRoute } from "../../Routes/routes";

interface Props {
  open: boolean;
  onClose: () => void;
  buttonLabel: string;
}

const PopUp = ({ open, onClose, buttonLabel }: Props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const theme: Theme = useTheme();

  const [loading, setLoading] = useState<boolean>(false);
  const [selectedAccount, setSelectedAccount] = useState<AccountModel | null>(null);

  const handleAccountSwitch = async () => {
    setLoading(true);

    await accountSwitch(selectedAccount?.id as number)
      .then((response) => {
        if (!response.data.hasErrors) {
          toast.success("Account Switched");
          dispatch(updateAccountAssigned(selectedAccount as InternalAccountAssignedModel));

          navigate(pathRoute.Dashboard, {
            replace: true,
          });

          onClose();
        }
      })
      .catch((error) => {
        //manage in the interceptor
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="select-account-dialog"
      aria-describedby="select-account-dialog"
      PaperProps={{ sx: { bgcolor: theme.palette.background.paper } }}
    >
      <DialogTitle sx={{ color: theme.palette.text.primary }} id="alert-dialog-title">
        Select an Account
      </DialogTitle>
      <DialogContent>
        <SelectAccount
          onChange={(option: any) => {
            if (option) {
              setSelectedAccount(option);
            } else {
              setSelectedAccount(null);
              // toast.error("You have to select an account");
            }
          }}
        />

        <Grid container justifyContent="center">
          <Button
            variant="contained"
            sx={{ mt: 2, backgroundColor: theme.palette.primary.main }}
            disabled={!selectedAccount}
            onClick={handleAccountSwitch}
          >
            {buttonLabel}
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default PopUp;
